export default __webpack_public_path__ + "static/media/3.f63a29de.jpg";